<div class="flex flex-col bg-white p-4 pb-0">
    <button
        class="flex-align-center word-break-break-word flex items-center justify-between"
        (click)="showAllClicked.emit()">
        <rwidget-bus-stop-header [stop]="stop"></rwidget-bus-stop-header>
        <ion-button
            class="orb-app-light:text-xm var-app-light:text-primary var-app-light-dark:text-xm text-xs font-semibold normal-case text-secondary dark:filter-yellow"
            [attr.aria-label]="'SHOW_ALL' | translate"
            size="small"
            fill="clear"
            >{{ 'SHOW_ALL' | translate }}
            <ion-icon
                class="ml-1 text-xxs dark:filter-yellow"
                title="{{ 'SHOW_ALL' | translate }}"
                src="{{ assetsPath$ | async }}/img/explore/icon-arrow-right.svg"
                >{{ 'SHOW_ALL' | translate }}</ion-icon
            >
        </ion-button>
    </button>

    <rwidget-caption *ngFor="let message of disruptionMessages" [disruptionMessage]="message"></rwidget-caption>

    <ng-container *ngIf="isLoadingDepartures === true && getDeparturePatch().length === 0; else departuresBlock">
        <div class="bg-white dark:bg-contrast-black">
            <div class="flex px-2 pt-2">
                <ridango-ui-skeleton-loader class="w-full" height="2.75rem" count="3"></ridango-ui-skeleton-loader>
            </div>
        </div>
    </ng-container>

    <div class="border-ironside_grey-100 mt-3 border-t border-solid dark:border-contrast-yellow">
        <ng-template #departuresBlock>
            <rwidget-departure-routes-list
                *ngIf="getDeparturePatch().length > 0"
                [showPatchSize]="showNumberOfTimes"
                [isStopShort]="true"
                [departures]="getDeparturePatch()"
                (departureSelect)="emitDepartureClick($event)"></rwidget-departure-routes-list>

            <div
                class="border-ironside_grey-100 mb-3 mt-3 border-t border-solid pt-3 text-center dark:border-contrast-yellow"
                *ngIf="getDeparturePatch().length === 0 && isLoadingDepartures === false">
                {{ 'NO_DEPARTURES_FOUND' | translate }}
            </div>
        </ng-template>
    </div>
</div>
